//正式环境配置
module.exports = {
    baseUrl : 'https://zjs-api.zhuangjiaosuo.cn/', //http://api.v2.yd.hichar.cn/
}